// FOLK Level to Location mapping configuration
export const folkLevelLocationMap = {
    "FOLK Foundation": "Annadanam Hall",
    "FOLK Prelims": "Gita Bhavan",
    "FOLK Enhanced": "FPH",
    "FOLK Graduate": "FPH",
    "FOLK Plus": "Gauranga Hall",
    "AOMC": "Nitai Hall"
};

export const getFolkLevelLocation = (folkLevel) => {
    return folkLevelLocationMap[folkLevel] || "";
};

